import { profile } from '@stereoagency/sanity-schema';

export const profilesQuery = profile.schema.builder
  .filter('_id in $ids')
  .pick(['_id', 'name', 'firstName', 'image'])
  .use();

export const draftModeProfilesQuery = profile.schema.builder
  .filter('_id in $ids')
  .pick(['_id', 'name', 'firstName', 'image'])
  .select(0, 1)
  .use();
